import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function CallingTreeAssignmentsValidator(
	activeControl: AbstractControl,
	backupControl: AbstractControl
): ValidatorFn {
	return (_control: AbstractControl): ValidationErrors | null => {
		return activeControl.value === backupControl.value
			? { callingTreeAssignments: true }
			: null;
	};
}
